import { memo } from 'react';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { PremiumIcon } from './icon';
import { IPremiumTooltipProps } from './interface';
import { useAuth } from '@core/features-core/auth/client';
import { useTheme } from '@mui/material';
import Image from 'next/image';
import { LPBaseURL } from '../utm-button/enum';
import { UTMButton } from '../utm-button';

export const PremiumTooltip = memo<IPremiumTooltipProps>(
  ({ children, description, utmContent }) => {
    const { userIsPremium } = useAuth();

    const theme = useTheme();

    if (userIsPremium) return children;

    return (
      <Tooltip
        componentsProps={{ tooltip: { sx: { p: 0 } } }}
        title={
          <Box
            borderRadius={1}
            textAlign="center"
            sx={{
              py: 3,
              px: 2,
              background: theme.palette.primary.main,
              maxWidth: '240px',
            }}
          >
            <PremiumIcon size={32} />
            <Typography
              fontWeight={700}
              variant="h4"
              color={theme.palette.primary.contrastText}
              gutterBottom
            >
              Funcionalidade Prime
            </Typography>

            <Typography
              variant="body2"
              color={theme.palette.primary.contrastText}
              mb={3}
            >
              {description}
            </Typography>

            <UTMButton
              utmContent={utmContent}
              variant="contained"
              color="secondary"
              sx={{
                color: theme.palette.primary.main,
              }}
            >
              Conheça o Retorno Prime
            </UTMButton>
          </Box>
        }
      >
        {children}
      </Tooltip>
    );
  }
);

export const ProTooltip = memo<IPremiumTooltipProps>(
  ({ children, description, utmContent }) => {
    const theme = useTheme();

    return (
      <Tooltip
        componentsProps={{ tooltip: { sx: { p: 0 } } }}
        title={
          <Box
            borderRadius={1}
            textAlign="center"
            sx={{
              py: 3,
              px: 2,
              background: '#0A1B23',
              maxWidth: '240px',
            }}
          >
            <Image
              src="/img/pro-icon.svg"
              alt="Retorno Pro"
              width={40}
              height={40}
            />
            <Typography
              fontWeight={700}
              variant="h4"
              sx={{ mt: 1 }}
              color={theme.palette.primary.contrastText}
              gutterBottom
            >
              Acesse o Pro
            </Typography>

            <Typography
              variant="body2"
              color={theme.palette.primary.contrastText}
              mb={3}
            >
              {description}
            </Typography>

            <UTMButton
              utmContent={utmContent}
              baseUrl={LPBaseURL.PRO}
              variant="contained"
              color="secondary"
              sx={{
                color: theme.palette.primary.main,
              }}
            >
              Conheça o Retorno Pro
            </UTMButton>
          </Box>
        }
      >
        {children}
      </Tooltip>
    );
  }
);
